(function ($) {
    $('.menu-header').click(function () {

        // do not toggle in editmode
        if($("body.editmode").length) return;

        var $this = $(this);
        $this.parents('.sticky-menu').toggleClass('active');
    });
})(window.jQuery);